export default __webpack_public_path__ + "static/media/default_machine_picture.d1387db5.png";